<template>
<div class="embed__content">
    <div
        v-if="embedPoster"
        class="embed-cover"
        :style="{'background-image': `url(${embedPoster})`}"
        @click="embedAutoPlay = true">
        <i v-if="!embedAutoPlay" class="fa fa-play-circle" />
        <div v-if="embedAutoPlay" class="frame-wrapper" v-html="autoplay_embed_content" />
    </div>
    <div
        v-else
        v-html="embedContent" />
</div>
</template>

<script>
    export default {
        name: 'EmbedContent',
        props: {
            embedContent: {type: String, default: ''},
            embedPoster: {type: String, default: ''},
        },
        data() {
          return {
            embedAutoPlay: false,
          }
        },
        computed: {
          autoplay_embed_content: function () {
            if (this.embedContent.includes('soundcloud.com')) {
              return this.embedContent.replace('auto_play=false', 'auto_play=true');
            } else {
              return this.embedContent
                  .replace(/><\/iframe>/, ' allow="autoplay;"></iframe>')
                  .replace(/(src="[^"]*)"/, function (match, p1) {
                    return (p1 + (p1.includes('?') ? '&' : '?') + 'autoplay=1"')
                  });
            }
          }
        },
    };
</script>

<style lang="scss">
    .embed__content > * {
        height: 100%;
    }
    .embed-cover {
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      display: flex;
      align-items: center;
      justify-content: center;
      .fa {
        font-size: 6rem;
        color: white;
        text-shadow: 0 0 1rem #000;
        opacity: 0.3;
        transition: all .25s ease-out;
      }
      &:hover .fa {
        opacity: 0.8;
      }
    }
    .frame-wrapper {
      width: 100%;
      height: 100%;
    }
</style>